export const DisplayBoardTypeTranslation: { [key: number]: string } = {
  1: $localize`Workflow`,
  2: $localize`Family`,
  3: $localize`Patient`,
  4: $localize`Asset PAR level`,
};
